export const ALL_REGION = { id: 0, name_url: 'toan-quoc', name: 'Toàn Quốc' };
export const ALL_SUB_REGION = { id: 0, name_url: 'tat-ca', name: 'Tất cả' };
export const ALL_WARD = { id: 0, name_url: 'tat-ca', name: 'Tất cả' };

export const ENTRYPOINT_TYPE = {
  CV: 'cv',
  NON_CV: 'non-cv',
};

export const ENTRYPOINT_MESSAGE = {
  CREATE_CV_SUCCESS:
    'Chia sẻ thành công. Giờ đây, Nhà tuyển dụng đã có thể liên hệ bạn khi có việc phù hợp.',
  UPDATE_CV_SUCCESS: 'Cập nhật hồ sơ thành công',
  NON_LOGIN:
    "Nhà tuyển dụng chỉ có thể xem hồ sơ ẩn danh của bạn <b style={{ color: '#FD213B' }}>trong 6 ngày nữa</b>. Đăng nhập để lưu lại hồ sơ tìm việc ngay.",
  CLOSED_CV: 'Việc Làm Tốt thấy bạn đã có hồ sơ xin việc. Bạn vẫn còn đang tìm việc chứ ?',
  OPEN_CV: 'Giờ đây, nhà tuyển dụng có thể xem hồ sơ của bạn. Bạn vẫn còn đang tìm việc chứ ?',
};

export const TOOLTIP_MESSAGE = {
  OPEN: 'Giờ đây Nhà tuyển dụng có thể thấy hồ sơ của bạn và mời đi làm ngay!',
  CLOSED: 'Bật lên để Nhà tuyển dụng có thể thấy hồ sơ của bạn và mời đi làm ngay!',
};

export const MODAL_BUTTON_LABEL = {
  APPLIED: 'ÁP DỤNG',
  LEAVE_INFO: 'Để lại liên hệ',
  UPGRADE_INFO: 'Đồng ý cập nhật',
};

export const MODAL_TITLE = {
  CHOOSE_REGION: 'Chọn khu vực',
  LEAVE_INFO: 'Chia sẻ thông tin',
  UPGRADE_INFO: 'Xác nhận cập nhật thông tin',
};

export const NON_LOGIN_ANNOUNCER_TEXT =
  'Khi chưa đăng nhập, thông tin của bạn sẽ được chia sẻ cho nhà tuyển dụng <b>trong 7 ngày</b>';

export const CONFIRM_UPGRADE_TEXT =
  'Chọn "Đồng ý cập nhật" để xác nhận lại các thông tin hồ sơ lưu lại đã chính xác, nhằm giúp Nhà Tuyển Dụng có thể liên hệ với bạn nhanh chóng.';

export const DENY_UPGRADE_TEXT =
  'Khi không đồng ý cập nhật thông tin có thể sẽ khiến bạn mất hồ sơ xin việc đã tạo trước đó tại Việc Làm Tốt. Bạn chắc chắn chứ? Hoặc bạn có thể “Trở về" để đồng ý cập nhật.';

export const REQUIRED_FIELDS = [
  'region_ids',
  'full_name',
  'phone_number',
  'birth_day',
  'preferred_job_types',
];
